(() => {
  const dialog = document.querySelector('[data-cart-straw-reminder]');
  const configElement = document.getElementById('BobaStrawReminderConfig');
  if (!dialog || !configElement || typeof dialog.showModal !== 'function') return;
  const config = JSON.parse(configElement.textContent);
  const storageKey = 'bobastore.straw-reminder.dismissed';
  const error = dialog.querySelector('[data-straw-error]');
  let dismissed = false;
  let bypass = false;
  let checking = false;
  let adding = false;
  let checkoutButton;
  try { dismissed = sessionStorage.getItem(storageKey) === 'true'; } catch (_) {}

  function rememberDismissal() {
    dismissed = true;
    try { sessionStorage.setItem(storageKey, 'true'); } catch (_) {}
  }

  function needsStraws(cart) {
    const items = cart.items || [];
    const hasBoba = items.some(item =>
      (item.product_type || '').startsWith(config.bobaTypePrefix) ||
      (item.handle || '').startsWith(config.bobaKitPrefix)
    );
    const hasStraws = items.some(item =>
      (item.product_type === config.strawType && !config.excludedStrawHandles.includes(item.handle)) ||
      config.kitsWithStraws.includes(item.handle)
    );
    return hasBoba && !hasStraws;
  }

  async function requestJson(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart request failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }

  function resumeCheckout() {
    if (!checkoutButton || !checkoutButton.isConnected || checkoutButton.disabled) return;
    bypass = true;
    try { checkoutButton.click(); } finally { bypass = false; }
  }

  async function checkBeforeCheckout(button) {
    if (checking || adding || dialog.open) return;
    checkoutButton = button;
    checking = true;
    button.setAttribute('aria-busy', 'true');
    let showReminder = false;
    try { showReminder = needsStraws(await requestJson(config.cartUrl)); } catch (_) {}
    checking = false;
    button.removeAttribute('aria-busy');
    if (showReminder) {
      error.hidden = true;
      dialog.showModal();
    } else {
      resumeCheckout();
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('#checkout[name="checkout"][form="cart"]');
    if (!button || button.disabled || bypass || dismissed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkBeforeCheckout(button);
  }, true);

  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (event.target.id !== 'cart' || button?.name !== 'checkout' || bypass || dismissed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkBeforeCheckout(button);
  }, true);

  dialog.addEventListener('cancel', event => {
    if (adding) event.preventDefault();
  });
  dialog.addEventListener('close', () => {
    rememberDismissal();
    if (checkoutButton?.isConnected) checkoutButton.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', async event => {
    if (adding) return;
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      return;
    }
    if (event.target.closest('[data-straw-dismiss]')) {
      dialog.close();
      return;
    }
    if (event.target.closest('[data-straw-continue]')) {
      rememberDismissal();
      dialog.close();
      resumeCheckout();
      return;
    }
    const addButton = event.target.closest('[data-straw-add]');
    if (!addButton) return;
    adding = true;
    error.hidden = true;
    const originalText = addButton.textContent;
    addButton.textContent = config.addingText;
    dialog.querySelectorAll('button').forEach(button => { button.disabled = true; });
    try {
      await requestJson(config.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addButton.dataset.strawAdd), quantity: 1 }] })
      });
      rememberDismissal();
      window.location.reload();
    } catch (_) {
      adding = false;
      addButton.textContent = originalText;
      dialog.querySelectorAll('button').forEach(button => { button.disabled = false; });
      error.hidden = false;
    }
  });
})();
